/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Accountdeletionemailsent3Inputs */

const en_accountdeletionemailsent3 = /** @type {(inputs: Accountdeletionemailsent3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent an email to ${i?.email}. Please check your inbox and follow the instructions to confirm account deletion.`)
};

const de_accountdeletionemailsent3 = /** @type {(inputs: Accountdeletionemailsent3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir haben eine E-Mail an ${i?.email} gesendet. Bitte überprüfe deinen Posteingang und folge den Anweisungen zur Bestätigung der Kontolöschung.`)
};

/**
* | output |
* | --- |
* | "We sent an email to {email}. Please check your inbox and follow the instructions to confirm account deletion." |
*
* @param {Accountdeletionemailsent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accountdeletionemailsent3 = /** @type {((inputs: Accountdeletionemailsent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdeletionemailsent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdeletionemailsent3(inputs)
	return de_accountdeletionemailsent3(inputs)
});
export { accountdeletionemailsent3 as "accountDeletionEmailSent" }